// @flow
import React from 'react';

import DirectusBlocks from 'components/fragments/DirectusBlocks';

type Props = {
  content: any,
  hideModal: () => void
};

function FidNotAwardedBadgeModal({ content, hideModal }: Props) {
  return (
    <div className="modal-content fid-modal fid-modal--grey-background">
      <i className="icon icon-close js-closeModal" onClick={hideModal} role="button" tabIndex="0" />
      <div className="modal__wrapper">
        <div className="modal__body modal__body--medium narrow-2">
          <img src={content.logo} alt="badge_logo" className="mb-1" />
          <h3 className="mb-3 ft-h2">{content.content_title}</h3>
          {!!content.content_description_1 &&
            !!content.content_description_1.blocks &&
            !!content.content_description_1.blocks.length && (
              <div className="mb-2 content_description_one">
                {content.content_description_1.blocks.map(block => (
                  <DirectusBlocks key={block.id} block={block} />
                ))}
              </div>
            )}
          {!!content.content_description_2 &&
            !!content.content_description_2.blocks &&
            !!content.content_description_2.blocks.length && (
              <div className="mb-2 content_description_two">
                {content.content_description_2.blocks.map(block => (
                  <DirectusBlocks key={block.id} block={block} />
                ))}
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default FidNotAwardedBadgeModal;
